<article class="workspace-option" [class.switch-mode]="isSwitchMode()"
  [class.selected]="isSwitchMode() && selected()" [class.active]="isSwitchMode() && active()" (click)="onSelect()"
  (keydown.enter)="onSelect()" (keydown.space)="onSelect(); $event.preventDefault()"
  [attr.role]="isSwitchMode() ? 'button' : null" [attr.tabindex]="isSwitchMode() ? 0 : null"
  [attr.aria-pressed]="isSwitchMode() ? selected() : null">

  <div class="workspace-info">
    <div class="workspace-logo" aria-hidden="true">
      @if (workspace().logoUrl) {
      <img [src]="workspace().logoUrl" [alt]="label()" (error)="onLogoError($event)">
      }
      <span>{{ initial() }}</span>
    </div>

    <div class="workspace-texts">
      <h3 class="workspace-name">{{ label() }}</h3>
      <span class="role-badge">{{ roleLabel() | translate }}</span>
    </div>
  </div>

  @if (!isSwitchMode()) {
  <div class="workspace-actions">
    @if (workspace().isRecent) {
    <span class="recent-badge">
      <mat-icon>schedule</mat-icon>
      {{ 'Reciente' | translate }}
    </span>
    }

    <button type="button" class="enter-button" (click)="onSelect(); $event.stopPropagation()">
      {{ 'Entrar' | translate }}
    </button>
  </div>
  } @else {
  <div class="workspace-selection-indicator" [class.visible]="selected()" aria-hidden="true">
    <mat-icon>chevron_right</mat-icon>
  </div>
  }
</article>
